export default __webpack_public_path__ + "static/media/sun-life.48ae11b4.png";